var React = require('react');

function IconRetry (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M106.026 61.28c0 24.999-20.36 45.359-45.359 45.359-9.898 0-19.284-3.156-27.187-9.088a6.483 6.483 0 0 1-1.294-9.078c2.149-2.854 6.217-3.438 9.075-1.291 5.64 4.236 12.358 6.47 19.426 6.47 17.848.001 32.374-14.524 32.374-32.372S78.54 28.907 60.688 28.907c-10.19.004-19.773 4.882-25.85 12.925H47.68a6.481 6.481 0 0 1 6.483 6.482 6.477 6.477 0 0 1-6.483 6.483H18.51a6.48 6.48 0 0 1-6.483-6.483V19.142a6.48 6.48 0 0 1 6.483-6.483 6.481 6.481 0 0 1 6.483 6.483V33.37C33.52 22.5 46.486 15.923 60.667 15.923c25 0 45.359 20.358 45.359 45.357Z"}));
}

IconRetry.defaultProps = {"viewBox":"0 0 119 119"};

module.exports = IconRetry;

IconRetry.default = IconRetry;
